const EventEmitter = require('eventemitter3');

const StandardStrike = require('../StandardStrike');
const BattleCalc = require('../../BattleCalc');
const { logError } = require('../../logger');

const VoidSpike = function (battleState) {
  this.handle = 'void_spike';
  this.magic = true;
  this.ranged = true;
  this.harm = true;

  this.standardStrike = new StandardStrike(this, battleState);

  this.eventEmitter = new EventEmitter();

  this.isLegal = function (actor, victim) {
    return true;
  };

  this.execute = function (actor, victim) {
    if (!actor || !actor.inPlay || !victim || (victim.unit && !victim.inPlay)) {
      return { success: false };
    }

    setTimeout(() => {
      try {
        if (
          !actor ||
          !actor.inPlay ||
          !victim ||
          (victim.unit && !victim.inPlay)
        ) {
          return;
        }

        const reflected = BattleCalc.rollForReflectMagic(victim);
        const finalActor = reflected ? victim : actor;
        const finalVictim = reflected ? actor : victim;

        const result = this.standardStrike.execute(
          finalActor,
          finalVictim,
          BattleCalc.getEquippedAbility(actor, 'void_spike').damage,
          false
        );
        result.abilityHandle = 'void_spike';
        result.actorId = finalActor.uid;
        result.victimId = finalVictim.uid;
        result.is_reflection = reflected;
        result.allPieces = battleState.allPieces;
        this.eventEmitter.emit('result', result);
      } catch (err) {
        logError(err, {
          module: 'VoidSpike',
          func: 'execute',
          actor,
          victim,
        });
      }
    }, BattleCalc.getCooldown(actor) * 1000 * 0.2);
  };
};
module.exports = VoidSpike;
